import { useSelector, useDispatch } from 'react-redux';
import { toggleTheme } from '@/store/slices/themeSlice.js';
import { useEffect, useState } from 'react';
import { cn } from '@/shared/utils/cn.js';
import Button from '@/shared/components/elements/Button';
import { Moon, Sun } from 'lucide-react';

export default function ThemeToggle() {
  const isDarkMode = useSelector((state) => state.theme.isDarkMode);
  const dispatch = useDispatch();
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    document.body.classList.toggle('dark-theme', isDarkMode);
  }, [isDarkMode]);

  const handleToggleTheme = () => {
    setIsAnimating(true);
    setTimeout(() => {
      dispatch(toggleTheme());
      setTimeout(() => setIsAnimating(false), 300);
    }, 150);
  };

  return (
    <div className="relative">
      <Button
        onClick={handleToggleTheme}
        variant="ghost"
        size="sm"
        className={cn(
          'bg-secondary-10 hover:bg-secondary-20 h-10 w-10 overflow-hidden rounded-full p-0 transition-all duration-300 dark:bg-gray-800 dark:hover:bg-gray-700',
          isAnimating ? 'scale-90' : 'scale-100',
        )}
        aria-label="تغییر تم"
        icon={
          <div className="relative flex h-full w-full items-center justify-center">
            {isDarkMode ? (
              <Sun
                className={cn(
                  'absolute text-yellow-400 transition-all duration-300',
                  isAnimating
                    ? 'scale-50 rotate-180 opacity-0'
                    : 'scale-100 opacity-100',
                )}
                size={20}
              />
            ) : (
              <Moon
                className={cn(
                  'text-secondary-100 absolute transition-all duration-300',
                  isAnimating
                    ? 'scale-50 rotate-180 opacity-0'
                    : 'scale-100 opacity-100',
                )}
                size={20}
              />
            )}
            <div
              className={cn(
                'bg-secondary-100 absolute h-5 w-5 rounded-full transition-all duration-300 dark:bg-yellow-400',
                isAnimating ? 'scale-100 opacity-100' : 'scale-0 opacity-0',
              )}
            />
          </div>
        }
        iconPosition="center"
      />
      {isDarkMode && (
        <div className="pointer-events-none absolute top-0 left-0 h-full w-full">
          <div className="absolute inset-0 animate-pulse rounded-full bg-gradient-to-tr from-blue-500/20 to-purple-500/20" />
        </div>
      )}
    </div>
  );
}
